import { Navigate } from "react-router-dom";
import { useAuth } from "@/providers/auth-provider";

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user == null) {
    // 권한이 없는 경우 리디렉션
    return <Navigate to="/" />;
  }
  // 권한이 있는 경우 자식을 렌더링
  return <>{children}</>;
}
